import BaseService from "../BaseService";
import _ from "lodash";

class StoreSettingService extends BaseService {
    getWebsiteSetting = async ({ info } = {}) => {
        var data = await this._api.get("/store/store_setting/getwebsitesetting");
        return data;
    };


    getStoreSetting = async ({ info } = {}) => {
        var data = await this._api.get("/store/store_setting/getstoresetting");
        return data;
    };

    // update = async ({ id, name }) => {
    //     var data = await this._api.post(`/product_tag/update`, { id, name });
    //     return data;
    // };

    // create = async ({ name }) => {
    //     var data = await this._api.post(`/product_tag/create`, { name });
    //     return data;
    // };


    // get = async (id) => {
    //     var data = await this._api.get(`/product_tag/get`, { params: { id: id } });
    //     return data;
    // };


    // delete = async (id) => {
    //     var data = await this._api.post(`/product_tag/delete`, { id: id });
    //     return data;
    // };



}
export default StoreSettingService;
